import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-suggestion',
  templateUrl: './search-suggestion.component.html',
  styleUrl: './search-suggestion.component.scss'
})
export class SearchSuggestionComponent {
  @Input()
  public searchSuggestions = []

  @Input()
  public historyStartsFromIndex = -1


  @Output()
  public suggestionClicked = new EventEmitter()

  @Output()
  public removeEntry = new EventEmitter()

  public openSuggestionText(text){
    this.suggestionClicked.next(text);
  }

  public removeSearch(entry){
   // console.log('removing', {entry})
    this.removeEntry.next(entry)


  }

}
